import { render, staticRenderFns } from "./Incidentes.vue?vue&type=template&id=376817c8"
import script from "./Incidentes.vue?vue&type=script&lang=js"
export * from "./Incidentes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports